export const environment = {
  production: true,
  EndpointCode: "dcfa18b2-c330-4d5f-bdba-ea8ecc3302b6",
  EndpointLogin: "https://app-guardian-identity-dev-eastus2-dubvgkfjgeefd5g6.z01.azurefd.net",
  // EndpointLogin: "https://app-identityservice-prod-eastus.azurewebsites.net",
  EndpointEntity: "fs.admin.ui",
}
